export default __webpack_public_path__ + "static/media/vaNoSurveyImgDefault.6b942a3a.png";